import NotificationLayout from '@/pages/notification/layout'
import NotificationIndexPage from '@/pages/notification/index'
import NotificationViewPage from '@/pages/notification/view'

var routes = {
	path: '/notifications',
	component: NotificationLayout,
	meta: {title: 'Уведомления', breadcrumb: 'Уведомления'},
	children: [
		{
			path: '',
			component: NotificationIndexPage,
			meta: {title: 'Уведомления'}
		}, {
			path: ':id',
			component: NotificationViewPage
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/notification.js